module.exports = {
      id: "ic-commodity-channel-index-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-commodity-channel-index-usage",
      toString: function () {
        return this.url;
      }
    }